// Vue
import {mixins} from 'vue-class-component'
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Mixins
import {FormInput} from './../../../mixins/form_input/FormInput'

// Components
import {Icon} from './../icon/Icon'
import {Button} from './../button/Button'
import {Input} from "../input/Input";

@Component({
    name: 'InputListMultiple',
    components: {
        Icon,
        Button,
        Input
    },
    mixins: [
        template,
    ]
})
export class InputListMultiple extends mixins(FormInput) {

    @Prop()
    public name!: string

    @Prop()
    public value!: string[]

    @Prop()
    public buttonText!: string

    @Prop({default: false})
    public disabled!: boolean

    @Prop({default: false})
    public readonly!: boolean

    @Prop({default: () => []})
    public displayErrors!: string[]

    @Prop({default: true})
    public showErrors!: boolean

    private internalValue: string[] = [""]

    public get disabledClass() {
        return this.disabled  ? `${this.$appPrefix}-input-list-multiple--disabled` : ''
    }

    public get filteredErrors() {
        return this.displayErrors.filter(error => error != '' && error != undefined && error != null )
    }

    public get errorClass() {
        return this.$slots['validation'] || this.filteredErrors.length > 0  ? `${this.$appPrefix}-input-list--error wb-e-inp-1--has-error` : ''
    }

    @Watch('value')
    private onValueChange() {
        this.internalValue = this.value
    }

    mounted() {
        if (this.value && this.value.length > 0) {
            this.internalValue = this.value;
        }
    }

    private onAdd() {
        this.$emit('input', [...this.internalValue, ""])
    }

    private onDelete(index) {
        let newValue = this.internalValue.slice();
        newValue.splice(index, 1)
        this.$emit('input', newValue)
    }

    private onChange(index, v) {
        let newValue = this.internalValue.slice();
        newValue[index] = v;

        this.$emit('input', newValue)
    }
}